import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, reactive, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import api from "@/api/system/auth";
import rolesApi from "@/api/system/roles";
import { ElMessage } from "element-plus";
import { useStore } from "@/store/index";
export default {
  __name: 'dialog',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  emits: ["loadList"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const store = useStore();
    const {
      t
    } = useI18n();
    const props = __props;
    const formRef = ref(null);
    const showDialog = ref(false);
    const emit = __emit;
    const title = ref("");
    const params = reactive({
      icon: "",
      // 图标
      component: "",
      // 组件路径
      order: "",
      // 排序
      redirect: "",
      // 重定向地址
      roleIds: [],
      // 角色id
      title: "",
      // 菜单名称（国际化）
      menuType: 0,
      // 类型: 0 目录 1 菜单 2 按钮
      interfacePath: "",
      // 接口地址
      pid: 0,
      // 父级菜单id
      addLog: 0,
      id: "",
      // 编辑的菜单id
      name: "",
      // 菜单名称
      path: "",
      // 路由地址
      hidden: 0 // 菜单是否隐藏
    });
    const menuData = ref([]);
    watch(() => props.list, val => {
      const mainCategory = {
        name: "主类目",
        // 主类目的名称
        id: 0,
        // 主类目的ID，通常为0表示根目录
        children: [...store.filterMenu(val)] // 如果主类目有子菜单可以在这里添加
      };
      menuData.value = [mainCategory];
    }, {
      deep: true
    });
    // 校验规则
    const rules = reactive({
      component: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("auth.table.componentPath")
        }),
        trigger: "blur"
      }],
      title: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("auth.dialog.menuInternationalization")
        }),
        trigger: "blur"
      }],
      menuType: [{
        required: true,
        message: t("common.pleaseSelect", {
          val: t("auth.table.type")
        }),
        trigger: "blur"
      }],
      pid: [{
        required: true,
        message: t("common.pleaseSelect", {
          val: t("auth.table.menu")
        }),
        trigger: "change"
      }],
      name: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("auth.table.menuName")
        }),
        trigger: "blur"
      }],
      path: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("auth.table.path")
        }),
        trigger: "blur"
      }],
      interfacePath: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("auth.table.interfacePath")
        }),
        trigger: "blur"
      }]
    });
    const loading = ref(false);
    const open = row => {
      title.value = row ? t("common.edit") + t("auth.table.menu") : t("common.add") + t("auth.table.menu");
      Object.assign(params, {
        icon: row ? row.meta.icon : "",
        component: row ? row.component : "",
        order: row ? row.order : "",
        redirect: row ? row.redirect : "",
        title: row ? row.meta.title : "",
        menuType: row ? row.menuType : 0,
        interfacePath: row ? row.interfacePath : "",
        id: row ? row.id : null,
        name: row ? row.name : "",
        path: row ? row.path : "",
        hidden: row ? row.hidden ? 1 : 0 : 0,
        pid: row ? row.pid : 0,
        addLog: row ? row.addLog : 0,
        roleIds: row ? row.roleIds || [] : []
      });
      showDialog.value = true;
    };
    const handleClose = () => {
      showDialog.value = false;
    };
    const handleConfig = () => {
      if (Array.isArray(params.pid)) {
        params.pid = params.pid[params.pid.length - 1];
      }
      formRef.value.validate(async valid => {
        if (!valid) return;
        loading.value = true;
        try {
          const {
            data
          } = params.id ? await api.menuEdit(params) : await api.menuAdd(params);
          if (data.code !== 0) return;
          handleClose();
          emit("loadList");
          ElMessage.success(t("action.success"));
        } finally {
          loading.value = false;
        }
      });
    };
    const rolesList = ref([]);
    const getRolesList = async () => {
      const {
        data: {
          data
        }
      } = await rolesApi.rolesList();
      rolesList.value = data.list;
    };
    onMounted(() => {
      getRolesList();
    });
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => showDialog.value = $event),
        title: title.value
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: handleClose,
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          loading: loading.value,
          onClick: handleConfig
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: params,
          ref_key: "formRef",
          ref: formRef,
          rules: rules,
          size: "large",
          "label-width": "90px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: _ctx.$t('auth.dialog.parent'),
              prop: "pid"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_cascader, {
                modelValue: params.pid,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.pid = $event),
                style: {
                  "width": "100%"
                },
                options: menuData.value,
                teleported: false,
                props: {
                  label: 'name',
                  value: 'id',
                  checkStrictly: true,
                  emitPath: false
                },
                placeholder: _ctx.$t('common.pleaseSelect', {
                  val: _ctx.$t('auth.dialog.parent')
                }),
                clearable: ""
              }, {
                default: _withCtx(({
                  node,
                  data
                }) => [_createElementVNode("span", null, _toDisplayString(data.name), 1), !node.isLeaf ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(data.children.length) + ") ", 1)) : _createCommentVNode("", true)]),
                _: 1
              }, 8, ["modelValue", "options", "placeholder"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.table.type'),
                prop: "menuType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: params.menuType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.menuType = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    value: 0
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("auth.table.catalogue")), 1)]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    value: 1
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("auth.table.menu")), 1)]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    value: 2
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("auth.table.btn")), 1)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.table.menuName'),
                prop: "name"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('auth.table.menuName')
                  }),
                  modelValue: params.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.name = $event),
                  clearable: ""
                }, null, 8, ["placeholder", "modelValue"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [params.menuType === 2 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.table.interfacePath'),
                prop: "interfacePath"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: params.interfacePath,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => params.interfacePath = $event),
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('auth.table.interfacePath')
                  })
                }, null, 8, ["modelValue", "placeholder"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.dialog.role'),
                prop: "roleIds"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: params.roleIds,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => params.roleIds = $event),
                  teleported: false,
                  multiple: "",
                  placeholder: _ctx.$t('common.pleaseSelect', {
                    val: _ctx.$t('auth.dialog.role')
                  }),
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesList.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      value: item.id,
                      label: item.name
                    }, null, 8, ["value", "label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('common.sort'),
                prop: "order"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: params.order,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => params.order = $event),
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('common.sort')
                  }),
                  clearable: ""
                }, null, 8, ["modelValue", "placeholder"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            }), params.menuType !== 2 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.table.componentPath'),
                prop: "component"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('auth.table.componentPath')
                  }),
                  modelValue: params.component,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => params.component = $event),
                  clearable: ""
                }, null, 8, ["placeholder", "modelValue"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            })) : _createCommentVNode("", true), params.menuType !== 2 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.dialog.icon'),
                prop: "icon"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: params.icon,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => params.icon = $event),
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('auth.dialog.icon')
                  })
                }, null, 8, ["modelValue", "placeholder"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.dialog.redirect'),
                prop: "redirect"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('auth.dialog.redirect')
                  }),
                  modelValue: params.redirect,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => params.redirect = $event),
                  clearable: ""
                }, null, 8, ["placeholder", "modelValue"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.table.path'),
                prop: "path"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: params.path,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => params.path = $event),
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('auth.table.path')
                  }),
                  clearable: ""
                }, null, 8, ["modelValue", "placeholder"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.dialog.menuInternationalization'),
                prop: "title"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: params.title,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => params.title = $event),
                  placeholder: _ctx.$t('common.pleaseEnter', {
                    val: _ctx.$t('auth.dialog.menuInternationalization')
                  }),
                  clearable: ""
                }, null, 8, ["modelValue", "placeholder"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.dialog.logRecord')
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: params.addLog,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => params.addLog = $event),
                  disabled: [0, 1].includes(params.menuType)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    value: 0
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.no")), 1)]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    value: 1
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.yes")), 1)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue", "disabled"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            }), params.menuType !== 2 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 3,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: _ctx.$t('auth.table.hidden'),
                prop: "hidden"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: params.hidden,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => params.hidden = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    value: 0
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("auth.table.show")), 1)]),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    value: 1
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("auth.table.hide")), 1)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};